export default "__VITE_ASSET__a4f51766__"